import 'ui-core/components/tabs/js/tabs';
import GetFTR from 'ui-core/components/getFTR/js/getFTR';

let tab;

if (UX.tab) {
    tab = UX.tab;
}

tab.on.dropdownBuild = function ($ele, index) {
    var $dropdownContainer = null,
        $activeTab = null;
    if (UX.dropBlock) {
        UX.dropBlock.init();
    }

    $ele.wrap('<div class="dropBlock no-auto-width" data-db-parent-of="dbTab-' + index + '"></div>');

    $dropdownContainer = $ele.closest('.dropBlock');
    $activeTab = $ele.find('.active a');

    if ($ele.find('>li').length === 1) {
        $dropdownContainer.prepend(
            `<a href='#' class='dropBlock__link no-pointer-events' data-db-target-for='dbTab-${index}'><span>${$activeTab.text()}</span></a>`
        );
        $ele.hide();
    } else {
        $dropdownContainer.prepend(
            `<a href='#'class='dropBlock__link' data-db-target-for='dbTab-${index}'><span>${$activeTab.text()}</span><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'><path d='M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z'/></svg></a>`
        );
        $ele.attr('data-db-target-of', 'dbTab-' + index);
    }
};

tab.check.empty = $tabItem => {
    const pane = document.querySelector(tab.getPaneTarget($tabItem)),
        tabItem = $tabItem[0];

    if (tabItem.matches('a:not([href^="#"])') || tabItem.classList.contains('external')) {
        // it is link and has no pane
        return;
    }

    if (!pane) {
        tabItem.classList.add('empty'); // disable tab nav because it has no pane
    }

    const hasNoContent = !pane.textContent.trim().length || pane.querySelector('.emptyTab') || !pane.childElementCount;

    if (pane && hasNoContent) {
        // if tab nav item is not an external link and check if pane is empty
        pane.classList.add('empty'); // add class to empty pane
        tabItem.classList.add('empty'); // add class to empty nav item
        return true; // abort
    } else {
        pane.classList.remove('empty'); // add class to empty pane
        tabItem.classList.remove('empty'); // add class to empty nav item
        return false; // abort
    }
};

// overridden to trigger changeActiveTab on clicking arrow slider btns
// todo: integrate when LIT-537781 is released
tab.control = () => {
    $body.on('click', '.tab-link', function (e) {
        e.preventDefault();
        const $this = $(this),
            documentScrollTop = $(document).scrollTop();

        $this.attr('data-scroll-back-to', documentScrollTop);
        tab.triggerExternal($this);
    });
    if (config.enableTabsTypeDropdown) {
        $body.on('click', '[data-mobile-toggle="dropdown"] a, .dropblock--tab a', function (e) {
            tab.on.select.dropdown($(this));

            if ($('.js--open[data-db-target-for]').length) UX.dropBlock.on.hide();
        });
    }
    $body.on('click', '.tab__nav a', function () {
        const _this = $(this);
        const tabId = tab.getPaneTarget(_this);
        $(document).trigger('tabs:changeActiveTab', {tabId: tabId});
        const $parent = _this.parents('.tab');
        if ($parent.hasClass('tab--lazy-load')) {
            if ($(tabId).attr('data-ajaxloaded') !== 'true') {
                tab.getContent($(tabId).find('.tab-lazy'));
            }
        }
        if (tab.isGetFTREnabled) {
            const getFTR = UX.getFTR || new GetFTR();
            if (tab.isGetFTRReferencesEnabled && _this[0].classList.contains('references-tab')) {
                getFTR.referencesTab();
            } else if (tab.isGetFTRCitedByEnabled && _this[0].classList.contains('related-tab')) {
                getFTR.relatedTab();
            }
        }
    });
    if (config.enableTabsTypeSwipeList) {
        $body.on('click touchend keydown', '.arrows-slide .next', function (e) {
            if (e.key && e.key !== 'Enter') return;
            if ($(this).hasClass(tab.swipeDisableClass)) return;
            e.preventDefault();
            let $activeNav = $(this).closest('.tab__nav').find('.active');
            let $activePane = $(this).closest('.tab').find('.tab__content .tab__pane.active');
            if ($activeNav.next().not('.arrows-slide').length > 0) {
                const $newActiveEl = $activeNav.removeClass('active').next().not('.arrows-slide');
                // these 2 lines are added
                let newActiveElTabId = tab.getPaneTarget($newActiveEl);
                $(document).trigger('tabs:changeActiveTab', {tabId: newActiveElTabId});
                $newActiveEl.addClass('active').show();
                $activePane.removeClass('active').next().addClass('active');
                tab.navToExternal($newActiveEl);
                if (!$activeNav.next().not('.arrows-slide').next().not('.arrows-slide').length) {
                    tab.toggleArrowAttrs($(this), true, 'data-no-next-text');
                }
                tab.toggleArrowAttrs($(this).closest('.arrows-slide').find('.prev'), false, 'data-prev-text');
            }
        });

        $body.on('click touchend keydown', '.arrows-slide .prev', function (e) {
            if (e.key && e.key !== 'Enter') return;
            if ($(this).hasClass(tab.swipeDisableClass)) return;
            e.preventDefault();
            let $activeNav = $(this).closest('.tab__nav').find('.active');
            let $activePane = $(this).closest('.tab').find('.tab__content .tab__pane.active');
            if ($activeNav.prev().not('.arrows-slide').length > 0) {
                const $newActiveEl = $activeNav.removeClass('active').prev().not('.arrows-slide');
                // these 2 lines are added
                let newActiveElTabId = tab.getPaneTarget($newActiveEl);
                $(document).trigger('tabs:changeActiveTab', {tabId: newActiveElTabId});
                $newActiveEl.addClass('active').show();
                $activePane.removeClass('active').prev().addClass('active');
                tab.navToExternal($newActiveEl);
                if (!$activeNav.prev().not('.arrows-slide').prev().not('.arrows-slide').length) {
                    tab.toggleArrowAttrs($(this), true, 'data-no-prev-text');
                }
                tab.toggleArrowAttrs($(this).closest('.arrows-slide').find('.next'), false, 'data-next-text');
            }
        });
    }
    // Get postback active tab
    tab.setPostbackActiveTab(tab.getPostbackActiveTab());
    tab.additionalControl();
};
